<template>
  <v-navigation-drawer
    app
    fixed
    clipped
    :width="$vuetify.breakpoint.mobile ? '100%' : 420"
    :mini-variant.sync="mini"
    mobile-breakpoint="0"
    v-model="nav">
    <v-list-item class="px-2">
      <v-btn block text @click.stop="mini = !mini" class="d-flex justify-end" >
        <v-icon v-if="mini">mdi-chevron-right</v-icon>
        <v-icon v-else>mdi-chevron-left</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>
    <v-card v-show="!mini">
      <v-tooltip bottom light>
        <template v-slot:activator="{ on }" style="padding-right: 5px;">
          <v-btn :icon="mini" v-if="canVideoConferencesWrite" rounded class="ml-4 my-5" :disabled="!allowCreate"
            data-testid="video-conference-create-btn" @click="openForm(false)" v-on="on">
            <v-icon left color="primary">
              mdi-plus
            </v-icon>
            <span v-if="!mini">{{ $t('videoconf.btn.create') }}</span>
          </v-btn>
        </template>
        <span>
          {{ $t('videoconf.tooltip.license', { license: this.formatLicenseVideoConfLimit, global: this.formatConfigMaxRoomPerRealm, total: totalConferences }) }}
        </span>
      </v-tooltip>
      <v-overlay absolute :value="loading">
        <v-progress-circular size="80" indeterminate>
        </v-progress-circular>
      </v-overlay>
      <v-subheader>
          <span class="mx-2">{{ $t('videoconf.filters') }}</span><ExcludeDynamicFilter/>
      </v-subheader>
      <v-list>
        <Conference v-for="(room, idx) in conferences"
          :room="room" :key="idx" @hangup="onHangup"/>
        <center v-if="conferences.length === 0"><i>{{ $t('videoconf.emptyText') }}</i></center>
      </v-list>
      <v-row align="end" justify="center">
        <Pagination @loading="loading = !loading" width="300px"/>
      </v-row>
    </v-card>
    <Form :show-form="showForm" :is-update="isUpdate" @close="closeForm()"/>
  </v-navigation-drawer>
</template>

<script>
import { mapGetters } from 'vuex'
import Conference from './item'
import Pagination from './pagination'
import Form from './form'
import ExcludeDynamicFilter from './exclude_dynamic_filter'

export default {
  name: 'video-conferences-list',
  data () {
    return {
      loading: false,
      mini: false,
      nav: true,
      showForm: false,
      isUpdate: false
    }
  },
  components: { Conference, Pagination, ExcludeDynamicFilter, Form },
  computed: {
    ...mapGetters({
      conferences: 'videoconfer/rooms',
      totalConferences: 'videoconfer/total',
      canVideoConferencesWrite: 'permissions/videoConfWrite',
      configMaxRoomPerRealm: 'videoConferenceConfig/maxRoomPerRealm',
      licenseVideoConfLimit: 'licenses/videoConfLimit'
    }),

    formatConfigMaxRoomPerRealm () {
      if (this.configMaxRoomPerRealm === -1) {
        return this.$t('videoconf.tooltip.unlimited')
      }
      return this.configMaxRoomPerRealm
    },

    formatLicenseVideoConfLimit () {
      if (this.licenseVideoConfLimit === 0) {
        return this.$t('videoconf.tooltip.unlimited')
      }
      return this.licenseVideoConfLimit
    },

    /* Based on licenses and configs:
    configMaxRoomPerRealm: global, licenseVideoConfLimit: per client */
    allowCreate () {
      if (this.configMaxRoomPerRealm === -1 && this.licenseVideoConfLimit === 0) {
        return true
      }
      if (this.configMaxRoomPerRealm === -1 && this.licenseVideoConfLimit > 0) {
        return this.licenseVideoConfLimit > this.totalConferences
      }
      if (this.configMaxRoomPerRealm > 0 && this.licenseVideoConfLimit === 0) {
        return this.configMaxRoomPerRealm > this.totalConferences
      }
      if (this.configMaxRoomPerRealm > 0 && this.licenseVideoConfLimit > 0) {
        return Math.min(this.configMaxRoomPerRealm, this.licenseVideoConfLimit) > this.totalConferences
      }
      return false
    }
  },
  methods: {
    onHangup (value) {
      this.$emit('hangup', true)
    },
    openForm (isUpdate) {
      this.isUpdate = isUpdate
      this.showForm = true
    },
    closeForm () {
      this.showForm = false
    }
  }
}
</script>

<style scoped>
</style>
